/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Preview_PageInputs */

const en_mobile_scan_preview_page = /** @type {(inputs: Mobile_Scan_Preview_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview page`)
};

const es_mobile_scan_preview_page = /** @type {(inputs: Mobile_Scan_Preview_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa`)
};

/**
* | output |
* | --- |
* | "Preview page" |
*
* @param {Mobile_Scan_Preview_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_preview_page = /** @type {((inputs?: Mobile_Scan_Preview_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Preview_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_preview_page(inputs)
	return en_mobile_scan_preview_page(inputs)
});